import { render, staticRenderFns } from "./screenModel.vue?vue&type=template&id=c19583ae&scoped=true"
import script from "./screenModel.vue?vue&type=script&lang=js"
export * from "./screenModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19583ae",
  null
  
)

export default component.exports